document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.custom-banner-section').forEach(function (section) {
    const loop = section.dataset.loop === 'true';
    const effect = section.dataset.effect || 'slide';
    const swiperEl = section.querySelector('.custom-banner-swiper');
    if (!swiperEl) return;

    const config = {
      loop: loop,
      navigation: {
        nextEl: section.querySelector('.swiper-button-next'),
        prevEl: section.querySelector('.swiper-button-prev'),
      },
      pagination: {
        el: section.querySelector('.swiper-pagination-custom'),
        clickable: true,
      },
    };

    if (effect !== 'slide') {
      config.effect = effect;
      if (effect === 'fade') {
        config.fadeEffect = { crossFade: true };
      }
    }

    new Swiper(swiperEl, config);
  });
});
